import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User, AuthResponse } from '../types';

interface AuthState {
  token: string | null;
  refreshToken: string | null;
  user: User | null;
  organizationId: string | null;
  isAuthenticated: boolean;
  setAuth: (auth: AuthResponse) => void;
  setOrganization: (orgId: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      refreshToken: null,
      user: null,
      organizationId: null,
      isAuthenticated: false,
      setAuth: (auth) =>
        set({
          token: auth.access_token,
          refreshToken: auth.refresh_token,
          user: auth.user,
          organizationId: auth.user.organization_id || null,
          isAuthenticated: true,
        }),
      setOrganization: (orgId) => set({ organizationId: orgId }),
      logout: () =>
        set({
          token: null,
          refreshToken: null,
          user: null,
          organizationId: null,
          isAuthenticated: false,
        }),
    }),
    {
      name: 'dominate-insights-auth',
    }
  )
);
